import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getClasses = ({
  disabled,
  dsf_selected,
  dsf_size,
  dsf_interactive,
  dsf_open
}) => {
  const classes = [
    "flex-auto",
    "flex",
    "gap-4",
    "relative",
    "items-center",
    "justify-center",
    "py-4",
    "rounded-sm",
    "outline-none",
    "truncate",
    "border"
  ];
  if (dsf_size === "smaller") {
    classes.push("px-8");
  } else {
    classes.push("px-10");
  }
  if (dsf_size === "smaller") {
    classes.push("h-24");
  } else {
    classes.push("h-32");
  }
  if (disabled) {
    classes.push("border-neutral-50");
  } else if (dsf_selected) {
    classes.push("border-secondary-100");
  } else if (dsf_open) {
    classes.push("border-neutral-200");
  } else {
    classes.push("border-neutral-100");
  }
  if (dsf_interactive) {
    if (disabled) {
      classes.push("focus:outline-none");
    } else {
      classes.push("focus-visible:border-secondary-200");
      classes.push(
        dsf_size === "smaller" ? "focus-visible:shadow-focus-secondary-sm" : "focus-visible:shadow-focus-secondary-md"
      );
    }
    if (!disabled) {
      if (dsf_selected) {
        classes.push("hover:border-secondary-200");
      } else {
        classes.push("hover:bg-secondary-50");
      }
    }
  }
  if (dsf_selected) {
    classes.push("bg-secondary-100");
  } else if (disabled || dsf_open) {
    classes.push("bg-neutral-50");
  } else {
    classes.push("bg-neutral-0");
  }
  const textClasses = disabled ? dsf_selected ? "text-secondary-200" : "text-neutral-400" : "text-neutral-700";
  classes.push(textClasses);
  if (disabled) {
    classes.push("cursor-not-allowed");
  }
  return concatClasses(classes);
};
const getTextClasses = ({ dsf_size }) => {
  const classes = ["whitespace-nowrap", "truncate"];
  if (dsf_size === "small") {
    classes.push("dsf-text-xs");
  } else {
    classes.push("dsf-text-xxs");
  }
  return concatClasses(classes);
};
export {
  getClasses,
  getTextClasses
};
